import type { ComponentOverride } from '../types';

export const MuiDialogContent: ComponentOverride<'MuiDialogContent'> = {
  MuiDialogContent: {
    styleOverrides: {
      root: {
        padding: '0 24px 24px 24px',
      },
    },
  },
};
